import { QueryClient } from "@tanstack/react-query";

/**
 * 创建应用级 Provider 容器。
 */
export function createAppProviders() {
  return {
    queryClient: new QueryClient({
      defaultOptions: {
        queries: {
          // 切回浏览器标签时不自动重拉，避免抽屉/列表无故转圈打断操作。
          refetchOnWindowFocus: false,
        },
      },
    }),
  };
}

